// src/components/forms/fields/subForms/array/ArraySubFormList.tsx
import React from "react";
import { useArraySubFormContext } from "./ArraySubFormContext";
import { NamePrefixProvider } from "../NamePrefixContext";
import { Grid2 as Grid, Grid2Props } from "@mui/material";
import { singleGridItem } from "../../defaultStyles";

interface Props extends Grid2Props {
  renderItem: (index: number, remove: () => void) => React.ReactNode;
}

const ArraySubFormList: React.FC<Props> = ({ renderItem, ...grid }) => {
  const { fields, remove } = useArraySubFormContext();

  return (
    <Grid container spacing={1} {...singleGridItem} {...grid}>
      {fields.map((field, index) => {
        const handleRemove = () => remove(index);
        return (
          <Grid
            container
            spacing={1}
            key={field.id}
            {...singleGridItem}
            {...grid}
          >
            <NamePrefixProvider prefix={`${index}`}>
              {renderItem(index, handleRemove)}
            </NamePrefixProvider>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default ArraySubFormList;
